import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSearch = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.2908 17.75C6.16848 17.75 2.75 14.35 2.75 10.25C2.75 6.15 6.16848 2.75 10.2908 2.75C14.413 2.75 17.8315 6.15 17.8315 10.25C17.8315 11.9275 17.2592 13.4879 16.3006 14.7461L20.9484 19.55C21.3505 19.95 21.3505 20.55 20.9484 20.95C20.7473 21.15 20.4457 21.25 20.2446 21.25C20.0435 21.25 19.7418 21.15 19.5408 20.95L14.8006 16.2354C13.5374 17.184 11.9727 17.75 10.2908 17.75ZM10.2908 3.75C6.6712 3.75 3.75543 6.65 3.75543 10.25C3.75543 13.85 6.6712 16.75 10.2908 16.75C13.9103 16.75 16.8261 13.85 16.8261 10.25C16.8261 6.65 13.9103 3.75 10.2908 3.75Z'
    />
  </svg>
);
export default SvgSearch;
